import FadedImage from './FadedImage'

export default FadedImage
